import { useApp } from '@/core/state/appStore'
import { isCategoryFilterActive } from '@/core/lib/viewInput'
import type { FilterMenuRow } from '@/core/components/dashboard/FilterMenu'
import { massnahmeViewConfig } from './massnahmeViewConfig'

export function useMassnahmeFilterRows(): { rows: FilterMenuRow[]; active: boolean } {
  const { state, dispatch } = useApp()
  const excludedByCategory = state.massnahmeViewFilter as unknown as Record<string, string[]>
  const toggleIn = (list: string[], value: string) =>
    list.includes(value) ? list.filter((v) => v !== value) : [...list, value]

  const rows: FilterMenuRow[] = (massnahmeViewConfig.filterCategories ?? []).map((cat) => ({
    kind: 'options',
    id: cat.id,
    label: cat.label,
    options: cat.catalog([]),
    excluded: excludedByCategory[cat.id] ?? [],
    count: (excludedByCategory[cat.id] ?? []).length,
    onToggle: (key) => {
      const current = excludedByCategory[cat.id] ?? []
      const next = toggleIn(current, key)
      dispatch({ type: 'SET_MASSNAHME_VIEW_FILTER', filter: { [cat.id]: next } })
    },
  }))

  return { rows, active: isCategoryFilterActive(excludedByCategory) }
}
